/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './treatment-plan.reducer';

export const TreatmentPlanDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const treatmentPlanEntity = useAppSelector(state => state.treatmentPlan.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="treatmentPlanDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.treatmentPlan.detail.title">TreatmentPlan</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.treatmentPlan.id">Id</Translate>
            </span>
          </dt>
          <dd>{treatmentPlanEntity.id}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="tinyMedicRestApp.treatmentPlan.date">Date</Translate>
            </span>
          </dt>
          <dd>{treatmentPlanEntity.date}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.treatmentPlan.active">Active</Translate>
            </span>
          </dt>
          <dd>{treatmentPlanEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.treatmentPlan.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{treatmentPlanEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.treatmentPlan.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{treatmentPlanEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.treatmentPlan.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{treatmentPlanEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.treatmentPlan.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{treatmentPlanEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.treatmentPlan.admission">Admission</Translate>
          </dt>
          <dd>{treatmentPlanEntity.admission ? treatmentPlanEntity.admission.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/treatment-plan" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/treatment-plan/${treatmentPlanEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TreatmentPlanDetail;
